import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { FormControl, Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Form, Card, InputGroup } from 'react-bootstrap';

import ReactCountryFlag from "react-country-flag"
import carbonEodPricingInputs from '../json/carbonEodPricingInputs.json';

import { Tooltip } from 'react-tooltip';

function Trend(props) {

    const [myLogs, setMyLogs] = useState([]);
    //const [triggerEffect, setTriggerEffect] = useState(false); // State variable to trigger the effect


    // Setting original values (pick the prior day data from the DB or JSON file)
    const [state, setState] = useState({
        inputOrganic: carbonEodPricingInputs.map(object => object.registry.organic),
        inputFairTrade: carbonEodPricingInputs.map(object => object.registry.fairTrade),
        myLogs2: []
    })

    // Show or hide card based on onClick event
    const [hidden, setHidden] = useState(true);

    const handleChange = evt => {

        // Set triggerEffect to true to trigger the effect
        //setTriggerEffect(true);


        const name = evt.target.name;
        const value =
            evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
        setState({
            ...state,
            [name]: value
        })

        // *****************************************
        // *** LOGS
        // *****************************************
        // Get current timestamp
        const currentTimestamp = new Date().getTime();
        // Convert timestamp to date object
        const date = new Date(currentTimestamp);
        // Format date
        const formattedDate = date.toLocaleString();
        //const jsonObject = { 'factor': name, 'value': value }; // JSON object to add
        const jsonObject = {timestamp: formattedDate, 'user': 'user1', factor: name, value: value };
        // to convert the object to a string.
        const jsonString = JSON.stringify(jsonObject);
        const newArray = [...myLogs, jsonString];
        // Update the state with the new array
        setMyLogs(newArray);



        // Passing all values to parent class
        //props["jsonResponseRegistry"]({ "name": name, "value": value });
        props[name](value);
    }


    // Effect to amend the array when state changes
    /*useEffect(() => {
        if (triggerEffect) {
            // Create a new array with the new element added
            const newArray = [...myLogs, state.inputOrganic];
            // Update the state with the new array
            setMyLogs(newArray);
            // Reset the triggerEffect state to false to avoid infinite loop
            setTriggerEffect(false);
        }
    }, [triggerEffect]); // Only run when myLogs changes or another attribute*/

    console.log(myLogs)

    return (
        <>

            <Card border="none" className="Card">
                <Card.Header className="Card-Header" style={{ cursor: 'pointer' }} onClick={() => setHidden(s => !s)}>Trends&nbsp;&nbsp;</Card.Header>
                {!hidden ? null :

                    <Card.Body className="Card-Body">

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    organic
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="inputOrganic" value={state.inputOrganic} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="100" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)" }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    fair trade
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="inputFairTrade" value={state.inputFairTrade} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="100" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)" }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>
                    </Card.Body >
                }
            </Card >
        </>
    );

}

export default Trend;